/*
 * @Description:
 * @Author:
 * @Date: 2023-04-25 16:18:32
 * @LastEditTime: 2023-07-17 10:30:56
 * @LastEditors: guohongyuan
 * @Usage:
 */
/**
 * @desc  [自定义校验规则]
 * @example
 *  import { validateRule } from "@/utils/validateRules";
 *  rules: [
 *     { validator: validateRule.emailValue, trigger: 'blur'}
 *  ]
 */

export function validatorPassword(rule, value, callback) {
  // let acount = /^[A-Za-z0-9]+$/;
  let acount = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&.,<>?:;"'[{}]|\\]])[A-Za-z\d@$!%*#?&.,<>?:;"'[{}]|\\]]{8,16}$/;

  if (value.length < 8 || value.length > 16) {
    callback(new Error("密码长度8到16位"));
  } else if (value && !acount.test(value)) {
    callback(new Error("请输入由大小写英文、数字、符号组合成的密码"));
  } else {
    callback();
  }
}

export function validatorPhone(rule, value, callback) {
  let acount =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  if (value && !acount.test(value)) {
    callback(new Error("请输入正确的手机号"));
  } else {
    callback();
  }
}

export function validatorEmail(rule, value, callback) {
  let acount = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_.-]+(\.[a-zA-Z0-9_.-]+)*\.[a-zA-Z0-9_.-]+$/;
  if (value && !acount.test(value)) {
    callback(new Error("请输入正确的邮箱号"));
  } else {
    callback();
  }
}

/**
 * 判断姓名是否正确
 */
export function validateName(rule, value, callback) {
  var regName = /^[\u4E00-\u9FA5]+$/;
  // /[^\u4E00-\u9FA5]/g
  if (value && !regName.test(value)) {
    callback(new Error("请输入正确的姓名"));
  } else {
    callback();
  }
}
// export const rule = {
//   /**
//    * 校验 请输入英文、数字
//    * 密码校验
//    */
//   ,
//   /**
//    * 校验 请输入中文、英文、数字包括下划线
//    * 名称校验
//    */
//   validatorNameCn(rule, value, callback) {
//     let acount = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
//     if (value && !acount.test(value)) {
//       callback(new Error("请输入中文、英文、数字包括下划线"));
//     } else {
//       callback();
//     }
//   },
//   /**
//    * 校验 请输入中文、英文、数字包括下划线
//    * 名称校验
//    */
//   validatorKey(rule, value, callback) {
//     let acount = /^[A-Z_]+$/;
//     if (value && !acount.test(value)) {
//       callback(new Error("请输入大写英文、下划线"));
//     } else {
//       callback();
//     }
//   },

//   /**
//    * 校验首尾空白字符的正则表达式
//    *
//    */
//   checkSpace(rule, value, callback) {
//     let longrg = /[^\s]+$/;
//     if (!longrg.test(value)) {
//       callback(new Error("请输入非空格信息"));
//     } else {
//       callback();
//     }
//   },
// };
